import { render, staticRenderFns } from "./panic-buying.vue?vue&type=template&id=b8625a66"
import script from "./panic-buying.vue?vue&type=script&lang=ts"
export * from "./panic-buying.vue?vue&type=script&lang=ts"
import style0 from "./panic-buying.vue?vue&type=style&index=0&id=b8625a66&prod&lang=stylus"
import style1 from "./panic-buying.vue?vue&type=style&index=1&id=b8625a66&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports